import { useSyncExternalStore } from "react";
import usePostMessageConfig from "./usePostMessageConfig";
import useMemoizedSelector from "../useMemoizedSelector";
import themes from "../../themes";

const useConfigStylesTheme = () => {
	const { createSelector, subscribe, findInConfig } = usePostMessageConfig();

	const memoizedSelector = useMemoizedSelector((theme) =>
		typeof theme === "string" ?
			//let customer choose theme by name (light/dark) - fallback to light if not found
			(themes[theme] || themes.light) :
			//let customer override with their own theme values - merge with light
			{ ...themes.light, ...theme },
	);

	return useSyncExternalStore(
		subscribe,
		createSelector((config) =>
			memoizedSelector(config ? findInConfig(config, "styles.theme") : "light")));
};

export default useConfigStylesTheme;
